import React from 'react';
import { Link } from 'react-router-dom';
import { getAnnouncementBar } from '../services/strapi';
import { useStrapi } from '../hooks/useStrapi';

// Use relative path /admin - Nginx proxies it to strapi:1337/admin
// This works with both direct IP access and Cloudflare Tunnel
export default function Header() {
  const { data: barData } = useStrapi(getAnnouncementBar);

  // Unwrap Strapi singleton response: data may be { data: { attributes: {...} } } or { attributes: {...} }
  const bar = barData?.data?.attributes || barData?.attributes || barData;

  const showBanner = bar && bar.isActive === true;

  const bannerStyle = showBanner
    ? {
        backgroundColor: bar.backgroundColor || '#4945FF',
        color: bar.textColor || '#FFFFFF',
      }
    : {};

  const bannerContent = showBanner ? (
    bar.link ? (
      <a
        href={bar.link}
        target={bar.link.startsWith('/') ? '_self' : '_blank'}
        rel="noreferrer"
        style={{ color: bar.textColor || '#FFFFFF', textDecoration: 'none' }}
      >
        {bar.message}
      </a>
    ) : (
      bar.message
    )
  ) : null;

  return (
    <>
      {showBanner && (
        <div className="cms-banner" style={bannerStyle}>
          {bannerContent}
        </div>
      )}
      <header className="header">
        <div className="container">
          <Link to="/" className="header__logo">
            Sikker<span>SMV</span>
          </Link>
          <nav className="header__nav">
            <Link to="/services">Services</Link>
            <Link to="/#blog">Blog</Link>
            <Link to="/#nyheder">Nyheder</Link>
            <Link to="/priser">Priser</Link>
            <Link to="/om-os">Om os</Link>
            <Link to="/kontakt" className="btn btn--primary">Kontakt os</Link>
          </nav>
        </div>
      </header>
    </>
  );
}
